import React from "react";
import useAuth from "../hooks/useAuth";
import { usePermission } from "../hooks/usePermission";

export const PermissionGate = ({
  required = [],
  all = false,
  children,
  fallback = null,
}) => {
  const { auth } = useAuth();

  const { hasAny, hasAll } = usePermission(auth?.role?.userPermissions || []);

  const allowed = all ? hasAll(required) : hasAny(required);

  if (!allowed) return fallback;
  return <>{children}</>;
};
